import styled from 'styled-components';

const BgPlaceholder = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	background-color: #00b140;
`;

export { BgPlaceholder };
